/** @format */

export function isObject(variable: any) {
    return (
        typeof variable === 'object' &&
        variable !== null &&
        !Array.isArray(variable)
    );
}

export function isRecordLike(
    isRecordLike: unknown
): isRecordLike is Record<string, unknown> {
    return isObject(isRecordLike);
}
